import baoRouter from "./bao-router";
window.SynosetApplicationId = "1a38b671-948c-42ee-b80d-f6b9a12814b6";
const Routes = {
    "startsynoset": {
        url: "SynosetStartModule",
        closable: false,
        objectId: "Start"
    },
    "ticket": {
        url: "Ticket",
        replaceRoute: "ticket/{id}"
    },
    "ticket/{id}": {
        url: "Ticket"
    },
    "mandatorcopywizard": {
        url: "Mandator/CopyWizard",
        objectId: "MandatorCopyWizard",
        closable: true
    },
    "object": {
        url: "ConfigurationItem",
        replaceRoute: "object/{id}"
    },
    "object/{id}": {
        url: "ConfigurationItem"
    },
    "person": {
        url: "ConfigurationItem/Person",
        replaceRoute: "person/{id}"
    },
    "person/{id}": {
        url: "ConfigurationItem/Person"
    },
    "contract": {
        url: "ConfigurationItem/Contract",
        replaceRoute: "contract/{id}"
    },
    "contract/{id}": {
        url: "ConfigurationItem/Contract"
    },
    "customer": {
        url: "ConfigurationItem/Customer",
        replaceRoute: "customer/{id}"
    },
    "customer/{id}": {
        url: "ConfigurationItem/Customer"
    },
    "project": {
        url: "ConfigurationItem/Project",
        replaceRoute: "project/{id}"
    },
    "project/{id}": {
        url: "ConfigurationItem/Project"
    },
    "dashboard": {
        url: "Dashboard",
        replaceRoute: "dashboard/{id}"
    },
    "dashboard/{id}": {
        url: "Dashboard"
    },
    "dashboard/{id}/{key}": {
        url: "Dashboard"
    },
    "reportcenter": {
        url: "ReportCenter/Index",
        replaceRoute: "reportcenter/{id}",
        closable: true
    },
    "reportcenter/{id}": {
        url: "ReportCenter/Index",
        closable: true
    },
    "reportcenter/{id}/{reportid}": {
        url: "ReportCenter/Index",
        closable: true
    },
    "reportcenter/{id}/{reportid}/{param}": {
        url: "ReportCenter/Index",
        closable: true
    },
    "ticketescalationdefinition": {
        url: "TicketEscalationDefinition",
        replaceRoute: "ticketescalationdefinition/{id}"
    },
    "ticketescalationdefinition/{id}": {
        url: "TicketEscalationDefinition"
    },
    "license/new/{softwarelicencepoolid}": {
        url: "License",
        replaceRoute: "License/{id}"
    },
    "softwaretype": {
        url: "SoftwareType",
        replaceRoute: "softwaretype/{id}"
    },
    "softwaretype/{id}": {
        url: "SoftwareType"
    },
    "softwarelicencetype": {
        url: "SoftwareLicenceType",
        replaceRoute: "softwarelicencetype/{id}"
    },
    "softwarelicencetype/{id}": {
        url: "SoftwareLicenceType"
    },
    "softwarelicensepool": {
        url: "SoftwareLicensePool",
        replaceRoute: "softwarelicensepool/{id}"
    },
    "softwarelicensepool/{id}": {
        url: "SoftwareLicensePool"
    },
    "softwarelicenseupgrade": {
        url: "SoftwareLicenseUpgrade",
        replaceRoute: "SoftwareLicenseUpgrade/{id}"
    },
    "softwarelicenseupgrade/{id}": {
        url: "SoftwareLicenseUpgrade"
    },
    "department": {
        url: "Department",
        replaceRoute: "Department/{id}"
    },
    "department/{id}": {
        url: "Department"
    },
    "building": {
        url: "Building",
        replaceRoute: "Building/{id}"
    },
    "building/{id}": {
        url: "Building"
    },
    "manufacturer": {
        url: "Manufacturer",
        replaceRoute: "Manufacturer/{id}"
    },
    "manufacturer/{id}": {
        url: "Manufacturer"
    },
    "location": {
        url: "Location",
        replaceRoute: "Location/{id}"
    },
    "location/{id}": {
        url: "Location"
    },
    "mandator": {
        url: "Mandator",
        replaceRoute: "Mandator/{id}"
    },
    "mandator/{id}": {
        url: "Mandator"
    },
    "serviceProvider": {
        url: "ServiceProvider",
        replaceRoute: "ServiceProvider/{id}"
    },
    "serviceProvider/{id}": {
        url: "ServiceProvider"
    },
    "ticketPriority": {
        url: "TicketPriority",
        replaceRoute: "TicketPriority/{id}"
    },
    "ticketPriority/{id}": {
        url: "TicketPriority"
    },
    "ticketStatus": {
        url: "TicketStatus",
        replaceRoute: "TicketStatus/{id}"
    },
    "ticketStatus/{id}": {
        url: "TicketStatus"
    },
    "ticketType": {
        url: "TicketType",
        replaceRoute: "TicketType/{id}"
    },
    "ticketType/{id}": {
        url: "TicketType"
    },
    "tickettemplate": {
        url: "TicketTemplate",
        replaceRoute: "TicketTemplate/{id}"
    },
    "tickettemplate/{id}": {
        url: "TicketTemplate"
    },
    "remindertickettemplate": {
        url: "ReminderTicketTemplate",
        replaceRoute: "ReminderTicketTemplate/{id}"
    },
    "remindertickettemplate/{id}": {
        url: "ReminderTicketTemplate"
    },
    "activity": {
        url: "Activity",
        replaceRoute: "Activity/{id}"
    },
    "activity/{id}": {
        url: "Activity"
    },
    "billingType": {
        url: "BillingType",
        replaceRoute: "BillingType/{id}"
    },
    "billingType/{id}": {
        url: "BillingType"
    },
    "billingFolder": {
        url: "BillingFolder",
        replaceRoute: "BillingFolder/{id}"
    },
    "billingFolder/{id}": {
        url: "BillingFolder"
    },
    "serviceCategoryType": {
        url: "ServiceCategoryType",
        replaceRoute: "ServiceCategoryType/{id}"
    },
    "serviceCategoryType/{id}": {
        url: "ServiceCategoryType"
    },
    "serviceCategoryGroup": {
        url: "ServiceCategoryGroup",
        replaceRoute: "ServiceCategoryGroup/{id}"
    },
    "serviceCategoryGroup/{id}": {
        url: "ServiceCategoryGroup"
    },
    "serviceLevelAgreement": {
        url: "ServiceLevelAgreement",
        replaceRoute: "ServiceLevelAgreement/{id}"
    },
    "serviceLevelAgreement/{id}": {
        url: "ServiceLevelAgreement"
    },
    "reminderType": {
        url: "ReminderType",
        replaceRoute: "ReminderType/{id}"
    },
    "reminderType/{id}": {
        url: "ReminderType"
    },
    "configurationItemStatus": {
        url: "ConfigurationItemStatus",
        replaceRoute: "ConfigurationItemStatus/{id}"
    },
    "configurationItemStatus/{id}": {
        url: "ConfigurationItemStatus"
    },
    "configurationItemType": {
        url: "ConfigurationItemType",
        replaceRoute: "ConfigurationItemType/{id}"
    },
    "configurationItemType/{id}": {
        url: "ConfigurationItemType"
    },
    "indicator": {
        url: "Indicator",
        replaceRoute: "Indicator/{id}"
    },
    "indicator/{id}": {
        url: "Indicator"
    },
    "configurationitemdiarycategory": {
        url: "ConfigurationItemDiaryCategory",
        replaceRoute: "ConfigurationItemDiaryCategory/{id}"
    },
    "configurationitemdiarycategory/{id}": {
        url: "ConfigurationItemDiaryCategory"
    },
    "holidaySchema": {
        url: "HolidaySchema",
        replaceRoute: "HolidaySchema/{id}"
    },
    "holidaySchema/{id}": {
        url: "HolidaySchema"
    },
    "holiday/person/{PersonId}/date/{Date}": {
        url: "Holiday",
        replaceRoute: "Holiday/{id}"
    },
    "holiday/{id}/person/{personId}": {
        url: "Holiday"
    },
    "holiday": {
        url: "Holiday",
        replaceRoute: "Holiday/{id}"
    },
    "holiday/prefill/{prefill}": {
        url: "Holiday",
        replaceRoute: "Holiday/{id}"
    },
    "holiday/{id}": {
        url: "Holiday"
    },
    "holidaylist": {
        url: "Holidaylist",
        objectId: "holidaylist"
    },
    "holidaylist/{personId}": {
        url: "Holidaylist",
        objectId: "holidaylist"
    },
    "holidayoverview": {
        url: "Holidaylist/Overview",
        objectId: "HolidayOverview"
    },
    "qualification": {
        url: "Qualification",
        replaceRoute: "Qualification/{id}"
    },
    "qualification/{id}": {
        url: "Qualification"
    },
    "bookHours": {
        url: "BookHours",
        objectId: "BookHours"
    },
    "termOfPayment": {
        url: "TermOfPayment",
        replaceRoute: "TermOfPayment/{id}"
    },
    "termOfPayment/{id}": {
        url: "TermOfPayment"
    },
    "salesGroup": {
        url: "SalesGroup",
        replaceRoute: "SalesGroup/{id}"
    },
    "salesGroup/{id}": {
        url: "SalesGroup"
    },
    "activitytype": {
        url: "ActivityType",
        replaceRoute: "ActivityType/{id}"
    },
    "activitytype/{id}": {
        url: "ActivityType"
    },
    "software": {
        url: "Software",
        replaceRoute: "software/{id}"
    },
    "software/{id}": {
        url: "Software"
    },
    "license": {
        url: "License",
        replaceRoute: "license/{id}"
    },
    "license/{id}": {
        url: "License"
    },
    "reminder": {
        url: "Reminder",
        replaceRoute: "Reminder/{id}"
    },
    "reminder/{id}": {
        url: "Reminder"
    },
    "reminder/new/{configurationitemid}": {
        url: "Reminder",
        replaceRoute: "Reminder/{id}"
    },
    "purchasevendor": {
        url: "PurchaseVendor",
        replaceRoute: "purchasevendor/{id}"
    },
    "purchasevendor/{id}": {
        url: "PurchaseVendor"
    },
    "manufacturerType": {
        url: "ManufacturerType",
        replaceRoute: "manufacturerType/{id}"
    },
    "manufacturerType/{id}": {
        url: "ManufacturerType"
    },
    "reminderTicket": {
        url: "ReminderTicket",
        replaceRoute: "ReminderTicket/{id}"
    },
    "reminderTicket/{id}": {
        url: "ReminderTicket"
    },
    "reminderTicket/new/{configurationitemid}": {
        url: "ReminderTicket",
        replaceRoute: "ReminderTicket/{id}"
    },
    "shifttype": {
        url: "ShiftType",
        replaceRoute: "ShiftType/{id}"
    },
    "shifttype/{id}": {
        url: "ShiftType"
    },
    "shiftgroup": {
        url: "ShiftGroup",
        replaceRoute: "ShiftGroup/{id}"
    },
    "shiftgroup/{id}": {
        url: "ShiftGroup"
    },
    'shiftgroup/{id}/{shiftplanmodelid}': {
        url: 'ShiftGroup'
    },
    "shiftplanmodel": {
        url: "ShiftPlanModel",
        replaceRoute: "ShiftPlanModel/{id}"
    },
    "shiftplanmodel/{id}": {
        url: "ShiftPlanModel"
    },
    "ShiftSchedule/TeamSchedule": {
        url: "ShiftSchedule/TeamSchedule",
        objectId: "TeamSchedule"
    },
    "WorkplacePlanning": {
        url: "WorkplacePlanning",
        objectId: "WorkplacePlanning"
    },
    "ShiftSchedule/FullYearSchedule": {
        url: "ShiftSchedule/FullYearSchedule",
        objectId: "FullYearSchedule"
    },
    "ShiftSchedule/DailyPlan/{shiftbookId}/{shiftGroupId}/{shiftTypeId}/{date}": {
        url: "ShiftSchedule/DailyPlan",
        objectId: "DailyPlan",
        replaceRoute: "ShiftSchedule/DailyPlan"
    },
    "ShiftSchedule/DailyPlan": {
        url: "ShiftSchedule/DailyPlan",
        objectId: "DailyPlan"
    },
    "newschedulegeneration": {
        url: "NewScheduleGeneration",
        objectId: "NewScheduleGeneration"
    },
    "NewScheduleGeneration/personId/{PersonId}/personName/{PersonName}": {
        url: "NewScheduleGeneration",
        objectId: "NewScheduleGeneration"
    },
    "installationtype": {
        url: "Installationtype",
        replaceRoute: "Installationtype/{id}"
    },
    "installationtype/{id}": {
        url: "Installationtype"
    },
    "operatingsystem": {
        url: "Operatingsystem",
        replaceRoute: "Operatingsystem/{id}"
    },
    "operatingsystem/{id}": {
        url: "Operatingsystem"
    },
    "operatingtype": {
        url: "Operatingtype",
        replaceRoute: "Operatingtype/{id}"
    },
    "operatingtype/{id}": {
        url: "Operatingtype"
    },
    "warrantyType": {
        url: "WarrantyType",
        replaceRoute: "WarrantyType/{id}"
    },
    "warrantyType/{id}": {
        url: "WarrantyType"
    },
    "purchaseType": {
        url: "PurchaseType",
        replaceRoute: "PurchaseType/{id}"
    },
    "purchaseType/{id}": {
        url: "PurchaseType"
    },
    "processor": {
        url: "Processor",
        replaceRoute: "Processor/{id}"
    },
    "processor/{id}": {
        url: "Processor"
    },
    "networkType": {
        url: "NetworkType",
        replaceRoute: "NetworkType/{id}"
    },
    "networkType/{id}": {
        url: "NetworkType"
    },
    "networkPortType": {
        url: "NetworkPortType",
        replaceRoute: "NetworkPortType/{id}"
    },
    "networkPortType/{id}": {
        url: "NetworkPortType"
    },
    "networkStatus": {
        url: "NetworkStatus",
        replaceRoute: "NetworkStatus/{id}"
    },
    "networkStatus/{id}": {
        url: "NetworkStatus"
    },
    "networkDuplexMode": {
        url: "NetworkDuplexMode",
        replaceRoute: "NetworkDuplexMode/{id}"
    },
    "networkDuplexMode/{id}": {
        url: "NetworkDuplexMode"
    },
    "offer": {
        url: "ConfigurationItem/Offer",
        replaceRoute: "Offer/{id}"
    },
    "offer/{id}": {
        url: "ConfigurationItem/Offer"
    },
    "purchaseVendorArticleType": {
        url: "PurchaseVendorArticleType",
        replaceRoute: "PurchaseVendorArticleType/{id}"
    },
    "purchaseVendorArticleType/{id}": {
        url: "PurchaseVendorArticleType"
    },
    "compressionType": {
        url: "CompressionType",
        replaceRoute: "CompressionType/{id}"
    },
    "compressionType/{id}": {
        url: "CompressionType"
    },
    "configurationItemTabBasedata": {
        url: "ConfigurationItemTabBasedata",
        replaceRoute: "ConfigurationItemTabBasedata/{id}"
    },
    "configurationItemTabBasedata/{id}": {
        url: "ConfigurationItemTabBasedata"
    },
    "universalField": {
        url: "UniversalField",
        replaceRoute: "UniversalField/{id}"
    },
    "universalField/{id}": {
        url: "UniversalField"
    },
    "universalField/copyfrom/{srcid}": {
        url: "UniversalField",
        replaceRoute: "UniversalField/{id}"
    },
    "configurationItemUniversalFieldTab/{id}": {
        url: "ConfigurationItemTabUniversalFieldTab"
    },
    "billinggeneration": {
        url: "BillingGeneration",
        objectId: "BillingGeneration"
    },
    "billingexport": {
        url: "BillingExport",
        objectId: "BillingExport"
    },
    "importServiceComponent": {
        url: "ImportServiceComponent",
        replaceRoute: "ImportServiceComponent/{id}"
    },
    "importServiceComponent/{id}": {
        url: "ImportServiceComponent"
    },
    "reportingUnitServiceProvider": {
        url: "ReportingUnitServiceProvider",
        replaceRoute: "ReportingUnitServiceProvider/{id}"
    },
    "reportingUnitServiceProvider/{id}": {
        url: "ReportingUnitServiceProvider"
    },
    "qualificationType": {
        url: "QualificationType",
        replaceRoute: "QualificationType/{id}"
    },
    "qualificationType/{id}": {
        url: "QualificationType"
    },
    "ShiftPlanMinRequired": {
        url: "ShiftPlanMinRequired",
        replaceRoute: "ShiftPlanMinRequired/{id}"
    },
    "shiftPlanMinRequired/{id}": {
        url: "ShiftPlanMinRequired"
    },
    "Country": {
        url: "Country",
        replaceRoute: "Country/{id}"
    },
    "Country/{id}": {
        url: "Country"
    },
    "LanguageConfigurationItem": {
        url: "LanguageConfigurationItem",
        replaceRoute: "LanguageConfigurationItem/{id}"
    },
    "LanguageConfigurationItem/{id}": {
        url: "LanguageConfigurationItem"
    },
    "ReportLayout": {
        url: "ReportLayout",
        replaceRoute: "ReportLayout/{id}"
    },
    "ReportLayout/{id}": {
        url: "ReportLayout"
    },
    'finitostart': {
        url: 'Start',
        closable: false,
        objectId: 'Start',
    },
    // by formid is old way (before projectx)
    'report/reportbyformid/{formid}': {
        jsUrl: 'Services/ReportService',
        jsFn: 'RedirectToReportByFormId'
    },
    'report/newinforeportbyformid/{formid}': {
        jsUrl: 'Services/ReportService',
        jsFn: 'RedirectToNewInfoReportByFormId'
    },
    // new way with shiftbook
    'report/reportbyshiftbookid/{shiftbookid}': {
        jsUrl: 'Services/ReportService',
        jsFn: 'RedirectToReportByShiftbookId'
    },
    'report/newinforeportbyshiftbookid/{shiftbookid}': {
        jsUrl: 'Services/ReportService',
        jsFn: 'RedirectToNewInfoReportByShiftbookId'
    },
    // Choose Shiftbook for new InfoReport
    'report/newinforeportbyshiftbookid/': {
        jsUrl: 'Services/ReportService',
        jsFn: 'DialogToRedirectToNewInfoReportByShiftbookid'
    },
    'report/OpenBySelection/{shiftbookid}': {
        jsUrl: 'Services/ReportService',
        jsFn: 'RedirectToReportByAllShiftbooks'
    },
    'report/InfoReportBySummaryReport/{startDate}/{endDate}/{infoId}': {
        jsUrl: 'Services/ReportService',
        jsFn: 'RedirectToInfoReportBySummaryReport'
    },
    'report/{id}/info/{infoid}': {
        url: 'Report'
    },
    'report/{id}': {
        url: 'Report'
    },
    'masterdata/state': {
        url: 'State',
        replaceRoute: 'masterdata/state/{id}'
    },
    'masterdata/state/{id}': {
        url: 'State'
    },
    'task/': {
        url: 'Task',
        replaceRoute: 'task/{id}'
    },
    'task/{id}': { // {id} ist InstructionId
        url: 'Task'
    },
    'task/{id}/{shiftbookid}': { // {id} ist InstructionId
        url: 'Task'
    },
    'instruction/{id}/contextShiftbook/{contextShiftbookId}/contextShiftType/{contextShiftType}': {
        url: 'Instruction',
    },
    'instruction/': {
        url: 'Instruction',
        replaceRoute: 'instruction/{id}'
    },
    'instruction/{id}/{shiftbookid}': { // {id} ist InstructionId
        url: 'Instruction'
    },
    'instruction/{id}': { // {id} ist InstructionId
        url: 'Instruction'
    },
    'whiteboard/{id}/{shiftbookid}': { // {id} ist InstructionId
        url: 'whiteboard'
    },
    'whiteboard/{id}/{reportId}': { // {id} ist InstructionId
        url: 'whiteboard'
    },
    'whiteboard/{id}': { // {id} ist InstructionId
        url: 'whiteboard'
    },
    'whiteboardbook': {
        url: 'WhiteboardBook',
        objectId: 'whiteboardbook',
        closable: true
    },
    'whiteboardbook/{whiteboardid}': {
        url: 'WhiteboardBook',
        objectId: 'whiteboardbook',
        closable: true
    },
    'masterdata/category/allindex': {
        url: 'MasterData/Category/allindex',
        objectId: 'category'
    },
    'masterdata/category/': {
        url: 'MasterData/Category',
        replaceRoute: 'MasterData/Category/{id}'
    },
    'masterdata/category/{id}': {
        url: 'MasterData/Category'
    },
    'masterdata/category/{id}/{parentId}': {
        url: 'MasterData/Category'
    },
    'masterdata/device3': {
        url: 'MasterData/Device3',
        replaceRoute: 'MasterData/Device3/{id}'
    },
    'masterdata/device3/{id}': {
        url: 'MasterData/Device3'
    },
    'masterdata/device4': {
        url: 'MasterData/Device4',
        replaceRoute: 'MasterData/Device4/{id}'
    },
    'masterdata/device4/{id}': {
        url: 'MasterData/Device4'
    },
    'masterdata/Tag': {
        url: 'MasterData/Tag',
        replaceRoute: 'MasterData/Tag/{id}'
    },
    'masterdata/Tag/{id}': {
        url: 'MasterData/Tag'
    },
    'masterdata/tagserver': {
        url: 'MasterData/TagServer',
        replaceRoute: 'MasterData/TagServer/{id}'
    },
    'masterdata/tagserver/{id}': {
        url: 'MasterData/TagServer'
    },
    'reportdispatcher': {
        url: 'ReportDispatcher',
        replaceRoute: 'ReportDispatcher/{id}'
    },
    'reportdispatcher/{id}': {
        url: 'ReportDispatcher'
    },
    'instructionbook': {
        url: 'InstructionBook/Index',
        objectId: 'instructionbook',
        closable: true
    },
    'instructionbook/{instructionbookid}': {
        url: 'InstructionBook/Index',
        objectId: 'instructionbook',
        closable: true
    },
    'taskbook': {
        url: 'TaskBook/Index',
        objectId: 'taskbook',
        closable: true
    },
    'taskbook/{taskbookid}': {
        url: 'TaskBook/Index',
        objectId: 'taskbook',
        closable: true
    },
    'MasterData/Equipment': {
        url: 'MasterData/Equipment',
        replaceRoute: 'MasterData/Equipment/{id}'
    },
    'MasterData/Equipment/{id}': {
        url: 'MasterData/Equipment'
    },
    'MasterData/Area': {
        url: 'MasterData/Area',
        replaceRoute: 'MasterData/Area/{id}'
    },
    'MasterData/Area/{id}': {
        url: 'MasterData/Area'
    },
    'TimeLine': {
        url: 'TimeLine/Index',
        objectId: 'TimeLine'
    },
    'MasterData/Tag/{id}': {
        url: 'MasterData/Tag'
    },
    'MasterData/ShiftGroup': {
        url: 'MasterData/ShiftGroup',
        replaceRoute: 'MasterData/ShiftGroup/{id}'
    },
    'MasterData/ShiftGroup/{id}': {
        url: 'MasterData/ShiftGroup'
    },
    'MasterData/ShiftType': {
        url: 'MasterData/ShiftType',
        replaceRoute: 'MasterData/ShiftType/{id}'
    },
    'MasterData/ShiftType/{id}': {
        url: 'MasterData/ShiftType'
    },
    'MasterData/TextModule': {
        url: 'MasterData/TextModule',
        replaceRoute: 'MasterData/TextModule/{id}'
    },
    'MasterData/TextModule/{id}': {
        url: 'MasterData/TextModule'
    },
    'MasterData/OrgUnit': {
        url: 'MasterData/OrgUnit',
        replaceRoute: 'MasterData/OrgUnit/{id}'
    },
    'MasterData/OrgUnit/{id}': {
        url: 'MasterData/OrgUnit'
    },
    'MasterData/Priority': {
        url: 'MasterData/Priority',
        replaceRoute: 'MasterData/Priority/{id}'
    },
    'MasterData/Priority/{id}': {
        url: 'MasterData/Priority'
    },
    'MasterData/TransferDefinition': {
        url: 'MasterData/TransferDefinition',
        replaceRoute: 'MasterData/TransferDefinition/{id}'
    },
    'MasterData/TransferDefinition/{id}': {
        url: 'MasterData/TransferDefinition'
    },
    'MasterData/InfoTemplate': {
        url: 'MasterData/InfoTemplate',
        replaceRoute: 'MasterData/InfoTemplate/{id}'
    },
    'MasterData/InfoTemplate/{id}': {
        url: 'MasterData/InfoTemplate'
    },
    'Shiftbook': {
        url: 'Shiftbook',
        replaceRoute: 'Shiftbook/{id}'
    },
    'Shiftbook/{id}': {
        url: 'Shiftbook'
    },
    'ShiftbookTab': {
        url: 'ShiftbookTab',
        replaceRoute: 'ShiftbookTab/{id}'
    },
    'ShiftbookTab/{id}': {
        url: 'ShiftbookTab'
    },
    'SummaryReportFilter': {
        url: 'SummaryReportFilter',
        replaceRoute: 'SummaryReportFilter/{id}'
    },
    'SummaryReportFilter/{id}': {
        url: 'SummaryReportFilter'
    },
    'TeamCalendar': {
        url: 'TeamCalendar',
        replaceRoute: 'TeamCalendar/{id}'
    },
    'TeamCalendar/{id}': {
        url: 'TeamCalendar'
    },
    'TeamCalendarView': {
        url: 'TeamCalendarView/Index',
        objectId: 'TeamCalendarView',
        closable: true
    },
    'TeamCalendarView/{teamcalendarid}': {
        url: 'TeamCalendarView/Index',
        objectId: 'TeamCalendarView',
        closable: true
    },
    'BriefingBook': {
        url: 'BriefingBook/Index',
        objectId: 'BriefingBook',
        closable: true
    },
    'BriefingBook/{briefingbookid}': {
        url: 'BriefingBook/Index',
        objectId: 'BriefingBook',
        closable: true
    },
    'Briefing/': {
        url: 'Briefing',
        replaceRoute: 'Briefing/{id}'
    },
    'Briefing/{id}/{shiftbookid}': { // {id} ist InstructionId
        url: 'Briefing'
    },
    'Briefing/{id}': { // {id} ist InstructionId
        url: 'Briefing'
    },
    'SummaryReportV2': {
        url: 'SummaryReportV2',
        replaceRoute: 'SummaryReportV2/{id}',
        objectId: 'SummaryReportV2'
    },
    'SummaryReportV2/{SummaryReportId}': { // {id} ist InstructionId
        url: 'SummaryReportV2',
        objectId: 'SummaryReportV2'
    },
    'Workplace': {
        url: 'Workplace',
        replaceRoute: 'Workplace/{id}'
    },
    'Workplace/{id}': {
        url: 'Workplace'
    },
    'MailTemplate/{id}': {
        url: 'MailTemplate'
    },
    'MailTemplate': {
        url: 'MailTemplate',
        replaceRoute: 'MailTemplate/{id}'
    },
    'WorkItem': {
        url: 'WorkItem',
        replaceRoute: 'WorkItem/{id}'
    },
    'WorkItem/{id}/{startdate}/{WorkItemCollectionId}': {
        url: 'WorkItem',
        replaceRoute: 'WorkItem/{id}'
    },
    'WorkItem/{id}/{startdate}/{WorkItemCollectionId}/{ConfigurationItemId}': {
        url: 'WorkItem',
        replaceRoute: 'WorkItem/{id}'
    },
    'WorkItem/{id}': {
        url: 'WorkItem'
    },
    'workitemcollection': {
        url: 'workitemcollection',
        objectId: 'workitemcollection',
        closable: true
    },
    'workitemcollection/{WorkItemCollectionId}': {
        url: 'workitemcollection',
        objectId: 'workitemcollection',
        closable: true
    },
    'InlineFrameReportRenderEngine/{reportId}': {
        url: 'InlineFrameReportRenderEngine',
        objectId: 'InlineFrameReportRenderEngine'
    },
    'InlineFrameReportRenderEngine': {
        url: 'InlineFrameReportRenderEngine',
        replaceRoute: 'InlineFrameReportRenderEngine/{id}',
        objectId: 'InlineFrameReportRenderEngine'
    },    
    'InlineFrameReport/{id}': {
        url: 'InlineFrameReport'       
    },
    'InlineFrameReport': {
        url: 'InlineFrameReport',
        replaceRoute: 'InlineFrameReport/{id}'    
    },
    'Question/{id}': {
        url: 'Question'
    },
    'Question': {
        url: 'Question',
        replaceRoute: 'Question/{id}'
    },
    'auditdefinition': {
        url: "Auditdefinition",
        replaceRoute: "Auditdefinition/{id}"
    },
    'auditdefinition/{id}': {
        url: "Auditdefinition"
    },
    'workitempriority': {
        url: 'workitempriority',
        replaceRoute: "workitempriority/{id}"
    },
    'workitempriority/{id}': {
        url: 'workitempriority'
    },
    'workitemtab/{id}': {
        url: "WorkItemTab"
    },
    'workitemtab': {
        url: "WorkItemTab",
        replaceRoute: "WorkItemTab/{id}"
    },
    'workitemtabtype/{id}': {
        url: "WorkItemTabType"
    },
    'workitemtabtype': {
        url: "WorkItemTabType",
        replaceRoute: "WorkItemTabType/{id}"
    },
    "workItemTabUniversalFieldTab/{id}": {
        url: "WorkItemTabUniversalFieldTab"
    },
    'workitemcategory': {
        url: 'workitemcategory',
        replaceRoute: "workitemcategory/{id}"
    },
    'workitemcategory/{id}': {
        url: 'workitemcategory'
    },
    'workitemtype': {
        url: 'workitemtype',
        replaceRoute: "workitemtype/{id}"
    },
    'workitemtype/{id}': {
        url: 'workitemtype'
    },
};
baoRouter.addRoutes(Routes);
export default Routes;